module.exports = __webpack_public_path__ + "static/media/chillax-packs@2x.1a879228.png";